import {
  SUPERSET_PROJECT_WISE_TICKETS,
  SUPERSET_PROJECT_WISE_TICKETS_SUCCESS,
  SUPERSET_PROJECT_WISE_TICKETS_ERROR,
  SUPERSET_PROJECT_WISE_TICKETS_EMPTY,
} from '../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SupersetProjectWiseTickets = (state = initialState, action) => {
  switch (action.type) {
    case SUPERSET_PROJECT_WISE_TICKETS:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_PROJECT_WISE_TICKETS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_PROJECT_WISE_TICKETS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SUPERSET_PROJECT_WISE_TICKETS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SupersetProjectWiseTickets;
